import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import "./assets/scss/styles.scss";
import parse from 'html-react-parser'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { getCredits } from '../../assets/js/api';
import { Helmet } from 'react-helmet';

export default function Credits() {

    const [creditsData, setCreditsData] = useState(null);

    useEffect(() => {
        getCredits('navarra106_64').then(
            credits => {
                credits = credits.data.result[0]
                setCreditsData(credits)
            }
        )
    }, [])

    return <div id="credits">
        { creditsData ?
            <>
                <Breadcrumbs currentSite={creditsData.term}/>
                <Helmet><title>{creditsData.term}</title></Helmet>
                <Container>
                    <div className='content'>
                        <h1>{creditsData.term}</h1>
                        <span className='text'>
                            { parse(creditsData.abstract) }
                        </span>
                    </div>
                </Container>
            </>
            : <Container className="alert-warning"> CARGANDO... </Container> }
    </div>;
}
